var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{staticStyle:{"position":"fixed","z-index":"10"}},[_c('Snow')],1),_c('layout-vertical',{scopedSlots:_vm._u([{key:"navbar",fn:function(ref){
var toggleVerticalMenuActive = ref.toggleVerticalMenuActive;
return [_c('navbar',{attrs:{"toggle-vertical-menu-active":toggleVerticalMenuActive}})]}}])},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }